var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _mask, _g2, _path12, _g3, _mask2, _g4, _path13, _path14, _mask3, _g5, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptySearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 151,
    viewBox: "0 0 157 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.7317 6.63672H0V140.69H99.7317V6.63672Z",
    fill: "#E1E0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0894 12.2891H7.77344V13.3655H42.0894V12.2891Z",
    fill: "#B6B5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0894 17.1338H7.77344V18.2102H42.0894V17.1338Z",
    fill: "#B6B5FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4996 12.2891H47.1836V13.3655H81.4996V12.2891Z",
    fill: "#E0E0E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8609 42.9775H52.5449V44.054H86.8609V42.9775Z",
    fill: "#E0E0E0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6675 45.9365H53.3516V47.0129H87.6675V45.9365Z",
    fill: "#E0E0E0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.275 48.8984H54.959V49.9749H89.275V48.8984Z",
    fill: "#E0E0E0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8609 90.6211H52.5449V91.6975H86.8609V90.6211Z",
    fill: "#E0E0E0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6675 93.583H53.3516V94.6595H87.6675V93.583Z",
    fill: "#E0E0E0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.275 96.543H54.959V97.6194H89.275V96.543Z",
    fill: "#E0E0E0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1597 32.748H8.27344V68.2793H44.1597V32.748Z",
    fill: "#C7C7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M43.0102 34.9004H9.53906V58.0493H43.0102V34.9004Z",
    fill: "url(#paint0_linear)"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 35,
    width: 34,
    height: 23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7793 35.1699H9.76953V57.5121H42.7793V35.1699Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7793 35.1699H9.76953V57.5121H42.7793V35.1699Z",
    fill: "#FBFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.283 58.3627L18.5957 45.441L22.0806 51.0928L29.5875 43.2882L36.0223 51.0928L41.6513 39.5195L56.128 62.6684L9.21094 61.0526L10.283 58.3627Z",
    fill: "#ECECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7175 42.4789C18.05 42.4789 19.1302 41.3943 19.1302 40.0563C19.1302 38.7184 18.05 37.6338 16.7175 37.6338C15.3849 37.6338 14.3047 38.7184 14.3047 40.0563C14.3047 41.3943 15.3849 42.4789 16.7175 42.4789Z",
    fill: "#ECECFF"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1597 80.3916H8.27344V115.923H44.1597V80.3916Z",
    fill: "#C7C7FF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M43.0102 82.5469H9.53906V105.696H43.0102V82.5469Z",
    fill: "url(#paint1_linear)"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 82,
    width: 34,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7793 82.8145H9.76953V105.157H42.7793V82.8145Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7793 82.8145H9.76953V105.157H42.7793V82.8145Z",
    fill: "#FBFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.63068 106.006L16.9434 93.0846L20.4282 98.7387L27.9352 90.9317L34.37 98.7387L39.999 87.1631L54.4756 110.312L7.55859 108.699L8.63068 106.006Z",
    fill: "#ECECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0651 90.1253C16.3976 90.1253 17.4779 89.0407 17.4779 87.7028C17.4779 86.3649 16.3976 85.2803 15.0651 85.2803C13.7326 85.2803 12.6523 86.3649 12.6523 87.7028C12.6523 89.0407 13.7326 90.1253 15.0651 90.1253Z",
    fill: "#ECECFF"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6824 -0.000286976L15.6582 131.481L113.477 151L139.501 19.518L41.6824 -0.000286976Z",
    fill: "#E1E0FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M122.24 63.6672L40.0488 48.0479L30.651 97.5005L112.842 113.12L122.24 63.6672Z",
    fill: "#C7C7FF"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 51,
    width: 86,
    height: 58
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.775 66.501L41.4922 51.8145L33.5641 93.5329L110.847 108.219L118.775 66.501Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.848 66.705L41.4922 51.8145L33.2307 95.2876L111.587 110.178L119.848 66.705Z",
    fill: "#FBFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3088 84.9115L54.1823 65.6425L58.1325 75.9884L72.8631 65.5376L80.9766 80.3296L93.8038 63.119L109.349 109.764L32.3088 94.8524L32.3088 84.9115Z",
    fill: "#ECECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2309 63.8249C51.0855 64.1774 52.8759 62.9535 53.2298 61.0914C53.5836 59.2293 52.367 57.434 50.5124 57.0815C48.6578 56.7291 46.8674 57.9529 46.5135 59.8151C46.1597 61.6772 47.3763 63.4725 49.2309 63.8249Z",
    fill: "#ECECFF"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M117.017 21.3392L47.5957 7.4873L47.3867 8.54309L116.808 22.395L117.017 21.3392Z",
    fill: "#B6B5FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2627 121.14L27.8418 107.288L27.6328 108.344L97.0537 122.196L97.2627 121.14Z",
    fill: "#B6B5FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2783 124.062L26.6348 113.358L26.4258 114.414L80.0693 125.118L80.2783 124.062Z",
    fill: "#B6B5FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M45.419 123.42L25.4355 119.433L25.2266 120.488L45.2101 124.476L45.419 123.42Z",
    fill: "#B6B5FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0999 20.4863L46.3906 13.5605L46.1817 14.6163L80.891 21.542L81.0999 20.4863Z",
    fill: "#B6B5FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M107.772 32.1202L45.1895 19.6328L44.9805 20.6886L107.563 33.176L107.772 32.1202Z",
    fill: "#B6B5FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2407 28.7491L43.9902 25.7061L43.7813 26.7618L59.0317 29.8048L59.2407 28.7491Z",
    fill: "#B6B5FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M112.21 45.6302L42.7891 31.7783L42.5801 32.8341L112.001 46.686L112.21 45.6302Z",
    fill: "#B6B5FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M111.009 51.7044L41.5879 37.8525L41.3789 38.9083L110.8 52.7602L111.009 51.7044Z",
    fill: "#B6B5FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M127.297 53.8682C123.989 50.4138 120.027 47.6587 115.642 45.7649C111.258 43.8711 106.541 42.8769 101.769 42.8409C96.9962 42.8048 92.2647 43.7275 87.8526 45.5548C83.4406 47.3821 79.4371 50.077 76.0779 53.4809C62.5333 67.1909 62.3037 89.5147 75.5521 103.515C81.3727 109.666 89.173 113.55 97.5721 114.48C105.971 115.41 114.427 113.326 121.443 108.598L147.311 135.617C147.631 135.951 148.071 136.144 148.532 136.153C148.994 136.162 149.441 135.986 149.774 135.665L156.22 129.441C156.553 129.12 156.746 128.679 156.755 128.215C156.764 127.751 156.589 127.303 156.269 126.968L130.398 99.9516C135.358 93.1291 137.766 84.7706 137.199 76.3433C136.631 67.916 133.126 59.9587 127.297 53.8682ZM119.239 97.287C115.59 100.81 110.982 103.167 105.998 104.06C101.014 104.953 95.8785 104.343 91.2404 102.306C86.6022 100.268 82.6699 96.8961 79.9407 92.615C77.2114 88.334 75.8078 83.3364 75.9073 78.2544C76.0069 73.1724 77.605 68.2341 80.4998 64.0641C83.3945 59.894 87.4559 56.6795 92.1702 54.8269C96.8845 52.9743 102.04 52.5669 106.985 53.6563C111.93 54.7456 116.442 57.2827 119.951 60.9468C122.281 63.3797 124.11 66.2497 125.336 69.3927C126.561 72.5358 127.157 75.8904 127.091 79.2649C127.025 82.6394 126.298 85.9679 124.951 89.0601C123.603 92.1524 121.662 94.9479 119.239 97.287Z",
    fill: "#ABA9FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3506 71.8083C79.4718 71.8083 79.4673 76.3007 82.3506 76.3007C85.234 76.3007 85.234 71.8083 82.3506 71.8083Z",
    fill: "#ABA9FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M102.42 57.4205C94.672 57.2453 87.6219 61.1477 83.8731 67.0392C82.6495 68.9616 86.1228 70.6603 87.3395 68.7472C90.4433 63.8699 96.3409 60.772 102.721 60.9333C109.406 61.1016 115.489 64.9417 118.71 70.2708C119.931 72.2922 123.134 70.4552 121.924 68.4452C118.001 61.9729 110.425 57.5934 102.42 57.4205Z",
    fill: "#ABA9FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 9195.36,
    y1: 8401.84,
    x2: 9195.36,
    y2: 6077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 9195.36,
    y1: 13234.6,
    x2: 9195.36,
    y2: 10909.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearch);
export default __webpack_public_path__ + "static/media/EmptySearch.023da8a0284018a09197c6c1caa87898.svg";
export { ForwardRef as ReactComponent };